export function validateSource(node) {
  var _node$source;

  return node.type === 'ReferenceNode' || node.type === 'UserClassifierGroupNode' ? {
    validateRemove: ((_node$source = node.source) === null || _node$source === void 0 ? void 0 : _node$source.relationType) === 'Indirect' ? 'Нельзя удалять элементы и папки из перенесенной иерархии' : '',
    validateCreate: node.source ? 'Нельзя создавать папки в перенесенной иерархии' : '',
    validateRename: node.source ? 'Нельзя переименовывать папки в перенесенной иерархии' : ''
  } : null;
}